export const getCategoryTranslations = state => {
  return state.translations
}

export const getCategoriesListSort = state => {
  return state.categoriesSortList
}

export const getCategoriesSortingEditKey = state => {
  return state.editSortingKey
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/getters.js